import React, { useContext, useEffect, useState } from 'react';
import { Resource } from 'sr-types/lib/search/v1/graphql';
import Loading from '../../common/components/Loading';
import { StepsIndexConstant } from '../../common/components/Stepper';
import { useStepper } from '../../common/components/StepperContext';
import { FormContext } from '../../common/form/FormContext';
import GalleryCard from '../../common/GalleryCard';
import I18n from '../../common/i18n/I18n';
import { TYPE_TO_ICON } from '../../common/icons/typeToIcon';
import { H } from '../../common/Layout';
import ResourceGalleryItem from '../common/ResourceGalleryItem';
import { getResourceDataAndTypeStepStates } from './resourceStepperUtils';

export default ({
    handleActivatedCreateStates,
    handleStepperData,
    isResourceTemplatesDataLoading = false
}: {
    handleActivatedCreateStates: (blankCreate: boolean, templateCreate: boolean) => void;
    handleStepperData: (data: any) => void;
    isResourceTemplatesDataLoading?: boolean;
}) => {
    const { state } = useContext(FormContext);
    const { getTemplateData, getStepData } = useStepper();

    const currentResourceTypeAndTemplate = getStepData(StepsIndexConstant.zero);

    const [templateResources, setTemplateResources] = useState([]);
    const [selectedId, setSelectedId] = useState<string>(currentResourceTypeAndTemplate?.selectedTemplateId);

    useEffect(() => {
        if (state?.type) {
            const resourceTemplates = getTemplateData(StepsIndexConstant.zero);
            setTemplateResources(resourceTemplates?.filter((resource: Resource) => resource.type === state.type));
        }
        if (state?.type && state?.type !== currentResourceTypeAndTemplate?.type) {
            handleActivatedCreateStates(true, false);
            handleStepperData({ type: state.type, values: null, resourceSchedule: null, selectedTemplateId: null });
        }
    }, [
        state?.type,
        isResourceTemplatesDataLoading,
        currentResourceTypeAndTemplate?.type,
        getTemplateData,
        handleActivatedCreateStates,
        handleStepperData
    ]);

    useEffect(() => {
        setSelectedId(currentResourceTypeAndTemplate?.selectedTemplateId);
    }, [currentResourceTypeAndTemplate?.selectedTemplateId]);

    const handleTemplateSelected = (resource: Resource) => {
        const { data, states } = getResourceDataAndTypeStepStates(resource, selectedId, state);

        setSelectedId(states.selectedId);
        handleActivatedCreateStates(states.isCreateBlankActivated, states.isTemplateActivated);
        handleStepperData({ ...data });
    };

    return (
        <H gap={2} sx={{ flexWrap: 'wrap', flexGrow: 1, justifyContent: 'flex-start' }}>
            {isResourceTemplatesDataLoading ? (
                <Loading />
            ) : !templateResources?.length ? (
                <I18n token="form.template.error.missing.message" />
            ) : (
                templateResources?.map((resource, index) => (
                    <GalleryCard
                        key={`${index}_${resource.id}`}
                        id={`${index}_${resource.id}`}
                        item={resource}
                        ItemRenderer={ResourceGalleryItem}
                        selectedId={selectedId}
                        onDetails={() => handleTemplateSelected(resource)}
                        handleSvgComponent={(item: Resource) => TYPE_TO_ICON[item.type]}
                        containerSx={{ width: { xs: '100%', md: '48%', lg: '190px' } }}
                    />
                ))
            )}
        </H>
    );
};
